export default [
  {
    id: 0,
    name: '選択してください'
  },
  {
    id: 1,
    name: '楊重機元請支給'
  },
  {
    id: 2,
    name: '特殊支保工元請支給'
  },
  {
    id: 3,
    name: '場内小運搬用台車元請支給'
  },
  {
    id: 4,
    name: '高所作業車元請支給'
  },
  {
    id: 5,
    name: '明細にない金物取付費用別途'
  },
  {
    id: 6,
    name: '搬出入トラックは4㌧ユニック車以上'
  },
  {
    id: 7,
    name: '搬出入トラックは7㌧ユニック車以上'
  },
  {
    id: 8,
    name: '支保工の足元活動防止はサポート底板と床面設置の貫板等との釘止めによる'
  },
  {
    id: 9,
    name: '自由記入'
  },
]



// WEBPACK FOOTER //
// ./src/company_user/libs/ConditionList.js